import React, { useState, useEffect } from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import "../assets/style.scss"
import { useAppSelector } from "../../../config/hook"
import { getConfigValue } from "@smpu-web/utils/utils"

const LandingHeader = () => {
  const sessionData = useAppSelector((state) => state.sessionData.response)

  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Block className="landing-header-text-wrapper">
        <Block className="landing-header-text">
          <Block dangerouslySetInnerHTML={{ __html: getConfigValue(sessionData?.configList, "UniversiteliAkbankli.Landing.Top") }} />
        </Block>
      </Block>
      <Image path={"./img/universiteliakbankli/landing-header-desktop-1.png"}
        className="landing-header-img" />
    </Block>
  )
}

export default LandingHeader
